export const FORM_FIELD_ALLOCATION_FORMAT = 'allocationFormat';
export const FORM_FIELD_ALLOCATION_DAYS = 'allocationDays';
export const FORM_FIELD_DATE_OF_RENEWAL = 'dateOfRenewal';
export const FORM_FIELD_ALLOW_CARRYOVER = 'allowCarryover';
export const FORM_FIELD_CARRYOVER_DAYS = 'carryoverDays';
export const FORM_FIELD_ALLOW_NEGATIVE_BALANCE = 'allowNegativeBalance';
export const FORM_FIELD_NEGATIVE_BALANCE_DAYS = 'negativeBalanceDays';
export const FORM_FIELD_HAS_MAX_LIMIT = 'hasMaxLimit';
export const FORM_FIELD_MAX_LIMIT_DAYS = 'maxLimitDays';
export const FORM_FIELD_IS_APPROVAL_REQUIRED = 'isApprovalRequired';
export const FORM_FIELD_REQUIRE_FILE_UPLOAD = 'requireFileUpload';
export const FORM_FIELD_ALLOW_HALF_DAY = 'allowHalfDay';
export const FORM_FIELD_ALLOW_QUARTER_DAY = 'allowQuarterDay';
export const FORM_FIELD_ALLOW_HOURLY_REQUESTS = 'allowHourlyRequests';
export const FORM_FIELD_CONSIDER_MEMBER_CAPACITY = 'considerMemberCapacity';
export const FORM_FIELD_CREDIT_ON_CREATION = 'creditOnCreation';
export const FORM_FIELD_PRORATE_ACCRUAL = 'prorateAccrual';
